const deleteActivity = (id) => `mutation MyMutation {
    deleteActivity(input: {id: "${id}"}) {
        id
    }
}`;

export default deleteActivity;